var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from 'common/UIToolKit/Icon.vue';
var UiTextInput = /** @class */ (function (_super) {
    __extends(UiTextInput, _super);
    function UiTextInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reveal = false;
        return _this;
    }
    Object.defineProperty(UiTextInput.prototype, "resettable", {
        get: function () {
            return this.text && this.showReset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiTextInput.prototype, "inputType", {
        get: function () {
            return this.type === 'password' && this.reveal ? 'text' : this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiTextInput.prototype, "rightIcons", {
        get: function () {
            var _this = this;
            var icons = [];
            if (this.resettable) {
                icons.push({
                    for: 'cross-c-f',
                    class: 'cursor-pointer w-4 h-4',
                    on: { click: this.reset },
                });
            }
            if (this.type === 'password') {
                icons.push({
                    for: 'eye',
                    class: 'cursor-pointer',
                    on: { click: function () { return _this.reveal = !_this.reveal; } },
                });
            }
            if (this.invalid) {
                icons.push({ for: 'warning-f', class: 'text-grape' });
            }
            if (this.validated && !this.invalid) {
                icons.push({ for: 'tick-square', class: 'text-success' });
            }
            return icons;
        },
        enumerable: false,
        configurable: true
    });
    UiTextInput.prototype.reset = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.$emit('textUpdate', '');
            _this.$emit('clear');
        });
    };
    UiTextInput.prototype.focus = function () {
        this.$refs.input.focus();
    };
    UiTextInput.prototype.select = function () {
        this.$refs.input.select();
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiTextInput.prototype, "text", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiTextInput.prototype, "icon", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], UiTextInput.prototype, "invalid", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], UiTextInput.prototype, "validated", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UiTextInput.prototype, "jumbo", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UiTextInput.prototype, "showReset", void 0);
    __decorate([
        Prop({ default: 'text' }),
        __metadata("design:type", String)
    ], UiTextInput.prototype, "type", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UiTextInput.prototype, "autofocus", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiTextInput.prototype, "id", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiTextInput.prototype, "name", void 0);
    UiTextInput = __decorate([
        Component({
            model: {
                prop: 'text',
                event: 'textUpdate',
            },
            components: {
                Icon: Icon,
            },
        })
    ], UiTextInput);
    return UiTextInput;
}(Vue));
export default UiTextInput;
